<div class="container-tab-lists">
<div class="tab-body">
        <div class="tab-content">
            <mat-tab-group [mat-stretch-tabs]="false">
                <mat-tab label="Nexus Product Master Data">
                    <kpiproducthierarchy-master></kpiproducthierarchy-master>
                </mat-tab>

                <mat-tab label="Nexus Product Mapping">
                    <kpiproducthierarchy-mapping></kpiproducthierarchy-mapping>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>